import { Injectable } from "@angular/core";
import { HttpService } from "../providers/http.service";
import { AppConfig } from "../app/app.config";

@Injectable()
export class GamMaService {
  constructor(private httpService: HttpService, private AppConfig: AppConfig) {}

  /**
   * 登录加玛棋牌
   * @param author An 2019-11-19
   */
  loginGamMa(kindId: string = "") {
    let url = AppConfig.GetProdUrl() + "/GamMa/Login";
    return this.httpService.post(url, { Enter: kindId });
  }
  /**
   * 平台转账到GamMa
   * @param author An 2019-11-19
   */
  transferToGamMa(money: number) {
    let url = AppConfig.GetProdUrl() + "/GamMa/TransferToGamMa";
    return this.httpService.post(url, { Money: money, Type: "1" });
  }
  /**
   * @params 加玛转出
   * @param author An 2019-11-19
   */
  transferFromGamMa(money: number) {
    let url = AppConfig.GetProdUrl() + "/GamMa/TransferFromGamMa";
    return this.httpService.post(url, { Money: money, Type: "2" });
  }
  /**
   * @params 获取GamMa余额
   * @param author An 2019-11-19
   */
  getGamMaBalance() {
    let url = AppConfig.GetProdUrl() + "/GamMa/GetBalance";
    return this.httpService.post(url, "");
  }
  /**
   * @params 获取GamMa转账记录
   * @param author An 2019-11-19
   */
  GamMaTransfer(params) {
    let url = AppConfig.GetProdUrl() + "/GamMa/GetTransferList";
    return this.httpService.post(url, params);
  }
  /**
   * @params 获取GamMa投注记录
   * @param author An 2019-11-19
   */
  getBettingList(params) {
    let url = AppConfig.GetProdUrl() + "/GamMa/GetBettingList";
    return this.httpService.post(url, params);
  }
  /**
   * @params 判断加玛棋牌是否开启
   * @param author An 2019-11-19
   */
  getGamMaIsOpen() {
    let url = AppConfig.GetProdUrl() + "/GamMa/GamMaIsOpen";
    return this.httpService.post(url, "");
  }
}



// WEBPACK FOOTER //
// ./src/services/gamMa.service.ts